<template>
  <div id="app" class="full-screen-app">
    <!-- 顶部选项卡 -->
    <div class="tabs-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="两品类组合" name="2"></el-tab-pane>
        <el-tab-pane label="三品类组合" name="3"></el-tab-pane>
        <el-tab-pane label="四品类组合" name="4"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 筛选条件表单 -->
    <div class="filter-container">
      <el-form :inline="true" class="filter-form">
        <div v-for="(filter, index) in parseInt(activeTab)" :key="index" class="filter-row">

          <el-form-item label="款号">
            <el-input v-model="filters[index].goodsInfo" placeholder="款号" clearable style="width: 120px"></el-input>
          </el-form-item>

          <el-form-item label="品牌">
            <el-select v-model="filters[index].brand" @change="handleBrandChange(index)" placeholder="请选择品牌" clearable
              style="width: 120px">
              <el-option v-for="brand in filterOptions.brands" :key="brand.value" :label="brand.label"
                :value="brand.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="大类">
            <el-select v-model="filters[index].mainCategory" @change="handleMainCategoryChange(index)"
              :disabled="!filters[index].brand" placeholder="请先选择品牌" clearable style="width: 150px">
              <el-option v-for="category in getMainCategories(index)" :key="category.value" :label="category.label"
                :value="category.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="小类">
            <el-select v-model="filters[index].subCategory" :disabled="!filters[index].mainCategory" placeholder="请先选择大类"
              clearable filterable style="width: 150px">
              <el-option v-for="subCategory in getSubCategories(index)" :key="subCategory.value"
                :label="subCategory.label" :value="subCategory.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="性别">
            <el-select v-model="filters[index].gender" placeholder="性别" clearable style="width: 100px">
              <el-option v-for="gender in filterOptions.genders" :key="gender.value" :label="gender.label"
                :value="gender.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="吊牌价">
            <el-input v-model="filters[index].min" placeholder="吊牌价-最低" style="width: 120px" clearable></el-input>
            <el-input v-model="filters[index].max" placeholder="吊牌价-最高" style="width: 120px" clearable></el-input>
          </el-form-item>

          <el-form-item label="单色库存">
            <el-input v-model="filters[index].singleStock" placeholder="单色库存" style="width: 120px" clearable></el-input>
          </el-form-item>

          <el-form-item label="整体库存">
            <el-input v-model="filters[index].totalStock" placeholder="整体库存" style="width: 120px" clearable></el-input>
          </el-form-item>
        </div>

        <!-- 统一的价格区间和查询按钮 -->
        <div class="filter-row">
          <el-form-item label="总吊牌价区间">
            <el-input v-model="priceRange.min" placeholder="最低价[默认200]" style="width: 150px"></el-input>
            <span class="separator">-</span>
            <el-input v-model="priceRange.max" placeholder="最高价[默认9999]" style="width: 150px"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">查询方案</el-button>
            <el-button @click="resetFilters">重置条件</el-button>
            <el-button type="primary" @click="showExportDialog">方案导出记录</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- 方案展示区域 -->
    <div class="scheme-container">
      <div class="scheme-header">
        <div class="scheme-info">
          <span class="title">组合方案</span>
          <span class="count">当前一共{{ schemes.length }}个方案，选择了{{ selectedCount }}个方案</span>
        </div>
        <div class="scheme-actions">
          <el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
          <el-button type="success" @click="generate" :loading="generating" :disabled="generating">生成方案</el-button>
        </div>
      </div>

      <div class="scheme-columns">
        <!-- 动态生成方案列 -->
        <div v-for="(scheme, index) in schemes" :key="index" class="scheme-column">
          <div class="column-header">
            <el-checkbox v-model="scheme.checked" @change="updateSelectedCount"></el-checkbox>
            <span class="total-price">总价: {{ scheme.totalPrice || '--' }}</span>
          </div>

          <!-- 商品列表 -->
          <div class="products-list">
            <div v-for="(product, pIndex) in scheme.products" :key="pIndex" class="product-item">
              <div class="product-image">
                <img :src="product.image || 'https://via.placeholder.com/150'" alt="商品图片">
              </div>

              <div class="product-info">
                <!-- 商品名称 -->
                <div class="product-name-row">
                  <strong>商品名称:</strong>
                  <div class="product-name-text">{{ product.goodsName }}</div>
                </div>

                <div class="product-name-row">
                  <strong>颜色及对应库存:</strong>
                  <div class="product-name-text">{{ product.colorInfos }}</div>
                </div>

                <!-- 其他信息 -->
                <div class="basic-info-grid">
                  <div>
                    单色库存:{{ product.singleStock || '--' }}
                  </div>
                  <div>
                    整体库存: {{ product.totalStock || '--' }}
                  </div>
                  <div>
                    品类: {{ product.category || '--' }}
                  </div>
                  <div>
                    品牌: {{ product.brand || '--' }}
                  </div>
                  <div>
                    款号: {{ product.code || '--' }}
                  </div>
                  <div>
                    性别: {{ product.gender || '--' }}
                  </div>
                  <div>
                    吊牌价: {{ product.tagPrice || '--' }}
                  </div>
                  <div>
                    采购价:{{ product.purchasePrice || '--' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-dialog title="文件生成成功" :visible.sync="downloadDialogVisible" width="30%" center>
        <span>PPT文件已生成，是否立即下载？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="downloadDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="downloadFile">立即下载</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 导出方案记录 -->
    <el-dialog title="方案数量导出" :visible.sync="exportDialogVisible" width="70%" top="5vh" custom-class="export-dialog">
      <div class="export-content">
        <div class="export-toolbar">
          <el-form :inline="true" class="filter-form">
            <el-form-item>
              <el-checkbox v-model="filterLargeSchemes" @change="handleFilterChange">
                仅显示方案数量大于15个的记录
              </el-checkbox>
            </el-form-item>
            <el-form-item v-if="filterLargeSchemes">
              <span class="filter-status">
                已筛选出 {{ filteredCount }} 个大方案
              </span>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="exportData" height="400px" stripe style="width: 100%" v-loading="exportLoading">
          <el-table-column prop="schemeName" label="方案名称" min-width="120"></el-table-column>
          <el-table-column prop="schemeCount" label="方案数量" width="100" align="center"></el-table-column>
          <el-table-column prop="downloadCount" label="下载次数" width="100" align="center"></el-table-column>
          <el-table-column label="操作" width="120" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="downloadExportItem(scope.row)"
                :loading="scope.row.downloading">
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 提示文字 -->
        <div class="export-tip">
          <el-alert title="当前仅显示近三天导出的方案" type="info" :closable="false" show-icon></el-alert>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      generating: false,
      activeTab: "2",
      filterOptions: {
        categories: {}, // 格式: {品牌: [{value,label,children:[...]}]}
        brands: [],
        genders: []
      },
      filters: [
        { brand: '', mainCategory: '', subCategory: '', gender: '', tagPrice: '', max: '', min: '', singleStock: '', totalStock: '', goodsInfo: '' },
        { brand: '', mainCategory: '', subCategory: '', gender: '', tagPrice: '', max: '', min: '', singleStock: '', totalStock: '', goodsInfo: '' },
        { brand: '', mainCategory: '', subCategory: '', gender: '', tagPrice: '', max: '', min: '', singleStock: '', totalStock: '', goodsInfo: '' },
        { brand: '', mainCategory: '', subCategory: '', gender: '', tagPrice: '', max: '', min: '', singleStock: '', totalStock: '', goodsInfo: '' }
      ],
      priceRange: {
        min: '',
        max: ''
      },
      schemes: [],
      selectAll: false,
      selectedCount: 0,
      filePath: null,
      downloadDialogVisible: false,
      exportDialogVisible: false,
      exportLoading: false,
      exportData: [],
      filterLargeSchemes: false, // 筛选大于15个方案的标志
      allExportData: [],         // 存储所有导出数据
    }
  },
  computed: {
    visibleFilters() {
      return this.filters.slice(0, parseInt(this.activeTab));
    }, filteredExportData() {
      if (this.filterLargeSchemes) {
        return this.allExportData.filter(item =>
          this.safeParseInt(item.schemeCount) > 15
        );
      }
      return this.allExportData;
    },

    filteredCount() {
      return this.filteredExportData.length;
    }
  },
  mounted() {
    this.loadFilterOptions();
  },
  methods: {
    handleFilterChange() {
      if (this.filterLargeSchemes) {
        this.exportData = this.allExportData.filter(item =>
          this.safeParseInt(item.schemeCount) > 15
        );
        this.$message.info(`已筛选出${this.exportData.length}个方案数量大于15的记录`);
      } else {
        this.exportData = [...this.allExportData];
        this.$message.info('已显示所有记录');
      }
    }, safeParseInt(value, defaultValue = 0) {
      if (value === null || value === undefined) return defaultValue;
      if (typeof value === 'number') return value;
      const parsed = parseInt(value.toString().replace(/[^\d]/g, ''));
      return isNaN(parsed) ? defaultValue : parsed;
    },
    async showExportDialog() {
      this.exportDialogVisible = true;
      this.exportLoading = true;
      this.filterLargeSchemes = false; // 重置筛选状态
      await this.loadExportData();
      this.exportLoading = false;
    },

    // 加载导出数据
    async loadExportData(page = 1) {
      try {
        const response = await axios.get('/zhi/cheng/goods/export/list', {
          params: {
            page,
            pageSize: 20,
            days: 3,
            minCount: 10
          }
        });

        if (response.data.code === 200) {
          this.allExportData = response.data.data || [];
          this.exportData = [...this.allExportData]; // 初始化显示所有数据
        } else {
          this.$message.error(response.data.message || '加载导出数据失败');
        }
      } catch (error) {
        console.error('加载导出数据失败:', error);
        this.$message.error('加载导出数据失败');
      }
    },
    // 下载单个导出项
    async downloadExportItem(item) {
      try {
        // 设置下载中状态
        this.$set(item, 'downloading', true);

        const response = await axios.get('/zhi/cheng/goods/export/download', {
          params: {
            schemeId: item.id,
            schemeName: item.schemeName
          }
        });

        if (response.data) {
          const downloadUrl = response.data;

          // 创建隐藏的下载链接
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = item.schemeName || '方案文件'; // 设置下载文件名
          link.style.display = 'none';

          // 添加到DOM并触发点击
          document.body.appendChild(link);
          link.click();

          // 清理DOM
          setTimeout(() => {
            document.body.removeChild(link);
          }, 100);

          this.$message.success('文件开始下载');

          // 更新下载次数
          if (item.downloadCount !== undefined) {
            item.downloadCount = parseInt(item.downloadCount || 0) + 1;
          }
        }
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('下载失败');
      } finally {
        this.$set(item, 'downloading', false);
      }
    },
    resetFilters() {
      // 重置价格区间
      this.priceRange = {
        min: '',
        max: ''
      };

      // 重置每个筛选行
      this.filters = this.filters.map(() => ({
        brand: '',
        mainCategory: '',
        subCategory: '',
        gender: '',
        tagPrice: '',
        max: '',
        min: '',
        singleStock: '',
        totalStock: '',
        goodsInfo: ''
      }));

      // 清空方案结果
      // this.schemes = [];
      this.selectedCount = 0;
      this.selectAll = false;

      this.$message.success('筛选条件已重置');
    },
    async loadFilterOptions() {
      try {
        const response = await axios.get('/zhi/cheng/goods/filter/info');
        if (response.data.code === 200) {
          this.filterOptions = {
            brands: response.data.data.brands || [],
            categories: response.data.data.categories || {}, // 确保是对象格式
            genders: response.data.data.genders || []
          };
        }
      } catch (error) {
        console.error('加载筛选选项失败:', error);
      }
    },
    // 获取大类选项
    getMainCategories(index) {
      const brand = this.filters[index].brand;
      if (!brand || !this.filterOptions.categories[brand]) return [];

      return this.filterOptions.categories[brand].map(item => ({
        value: item.value,
        label: item.label
      }));
    },
    // 获取小类选项
    getSubCategories(index) {
      const brand = this.filters[index].brand;
      const mainCategory = this.filters[index].mainCategory;

      if (!brand || !mainCategory || !this.filterOptions.categories[brand]) return [];

      const mainCat = this.filterOptions.categories[brand].find(
        item => item.value === mainCategory
      );

      if (!mainCat || !mainCat.children) return [];

      return mainCat.children.map(item => ({
        value: item.value,
        label: item.label
      }));
    },
    // 品牌变更处理
    handleBrandChange(index) {
      this.filters[index].mainCategory = '';
      this.filters[index].subCategory = '';
    },
    // 大类变更处理
    handleMainCategoryChange(index) {
      this.filters[index].subCategory = '';
    },
    handleTabChange() {
      this.schemes = [];
    },
    search() {
      const invalidFilters = this.visibleFilters.filter(filter => {
        // 如果填写了款号，则跳过品牌/大类/小类的验证
        if (filter.goodsInfo && filter.goodsInfo.trim() !== '') {
          return false; // 不视为无效
        }
        // 否则检查品牌/大类/小类是否填写
        return !filter.brand || !filter.mainCategory || !filter.subCategory;
      });

      if (invalidFilters.length > 0) {
        const errorMessages = invalidFilters.map((_, index) =>
          `第${index + 1}行：请填写款号或完成品牌、大类和小类的选择`
        );
        this.$message.error(errorMessages.join('；'));
        return;
      }

      const requestData = {
        activeTab: this.activeTab,
        min: this.priceRange.min === '' ? 200 : this.priceRange.min,
        max: this.priceRange.max === '' ? 9999 : this.priceRange.max,
        filters: this.visibleFilters.map(filter => ({
          brand: filter.brand,
          mainCategory: filter.mainCategory,
          channel: filter.subCategory,
          gender: filter.gender,
          tagPrice: filter.tagPrice,
          max: filter.max,
          min: filter.min,
          singleStock: filter.singleStock || '',
          totalStock: filter.totalStock || '',
          goodsInfo: filter.goodsInfo || ''
        }))
      };

      axios.post('/zhi/cheng/goods/scheme', requestData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if (response.data.code === 200) {
            this.schemes = response.data.data.map(scheme => ({
              checked: scheme.checked || false,
              products: scheme.products.map(product => ({
                image: product.image,
                goodsId: product.goodsId,
                code: product.code,
                goodsName: product.goodsName,
                category: product.category || '未分类',
                brand: product.brand || '未知品牌',
                gender: this.formatGender(product.gender),
                tagPrice: `¥${product.tagPrice}`,
                purchasePrice: `¥${product.purchasePrice}`,
                singleStock: product.singleStock,
                totalStock: product.totalStock,
                colorInfos: product.colorInfos
              })),
              totalPrice: `¥${scheme.totalPrice}`
            }));

            this.updateSelectedCount();
          } else {
            this.$message.error(response.data.message || '获取方案失败');
          }
        })
        .catch(error => {
          console.error('查询失败:', error);
          this.$message.error('查询方案失败');
        });
    },
    formatGender(genderValue) {
      const genderMap = {
        '0': '男',
        '1': '女',
        '2': '中性',
        '3': '儿童',
      };
      return genderMap[genderValue] || genderValue;
    },
    generate() {
      if (this.selectedCount === 0) {
        this.$message.error('请先选择方案');
        return;
      }

      // 检查是否超过15个方案
      if (this.selectedCount > 15) {
        // 不显示加载状态，直接进行异步请求
        const requestData = this.schemes
          .filter(scheme => scheme.checked)
          .map(scheme => ({
            ...scheme,
            products: scheme.products.map(({ image, ...rest }) => rest)// eslint-disable-line no-unused-vars
          }));

        // 提示用户
        this.$alert(
          '多方案生成任务已提交，请稍后到"方案数量导出"列表中查看',
          '任务提交成功',
          {
            confirmButtonText: '确定',
            type: 'success'
          }
        );

        // 异步发送请求，不阻塞UI
        axios.post('/zhi/cheng/goods/new/generate', requestData)
          .then(response => {
            if (response.data.code === 200) {
              this.$message.success('多方案生成任务已完成，请到"方案数量导出"列表中查看');
            } else {
              // this.$message.error(response.data.message || '多方案生成任务提交失败');
            }
          })
          .catch(error => {
            console.error('多方案生成失败:', error);
            this.$message.error('多方案生成任务提交失败');
          });

        return; // 直接返回，不执行后续代码
      }

      // 15个及以下的方案，保持原有逻辑
      this.generating = true;

      const requestData = this.schemes
        .filter(scheme => scheme.checked)
        .map(scheme => ({
          ...scheme,
          products: scheme.products.map(({ image, ...rest }) => rest)// eslint-disable-line no-unused-vars
        }));

      axios.post('/zhi/cheng/goods/new/generate', requestData)
        .then(response => {
          if (response.data.code === 200) {
            this.generating = false;
            this.filePath = response.data.data;
            this.$message.success('新方案生成成功！');
            this.downloadDialogVisible = true;
          } else {
            this.$message.error(response.data.message || '生成方案失败');
            this.generating = false;
          }
        })
        .catch(error => {
          console.error('生成方案失败:', error);
          this.generating = false;
          this.$message.error('生成方案失败');
        });
    },
    downloadFile() {
      if (!this.filePath) return;
      window.open(this.filePath, '_blank');
      this.downloadDialogVisible = false;
      this.$message.success('开始下载文件');
    },
    handleSelectAll(checked) {
      this.schemes.forEach(scheme => {
        scheme.checked = checked;
      });
      this.updateSelectedCount();
    },
    updateSelectedCount() {
      this.selectedCount = this.schemes.filter(scheme => scheme.checked).length;
      this.selectAll = this.selectedCount === this.schemes.length;
    }
  }
}
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f5f7fa;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

#app.full-screen-app {
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f5f7fa;
}

/* 顶部选项卡 */
.tabs-container {
  background: white;
  border-radius: 8px 8px 0 0;
  padding: 0 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.tabs-container .el-tabs__item {
  font-size: 16px;
  padding: 0 25px;
  height: 60px;
  line-height: 60px;
}

/* 筛选条件区域 */
.filter-container {
  background: white;
  border-radius: 0 0 8px 8px;
  padding: 20px 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.filter-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px 30px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #eee;
}

.filter-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.filter-row .el-form-item {
  margin-bottom: 0;
}

.separator {
  margin: 0 10px;
  color: #909399;
}

/* 方案展示区域 */
.scheme-container {
  background: white;
  border-radius: 8px;
  padding: 25px 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.scheme-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.scheme-info {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.count {
  margin-left: 15px;
  font-size: 14px;
  color: #606266;
}

.scheme-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.scheme-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 25px;
}

.scheme-column {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
  background: #fff;
  transition: all 0.3s ease;
}

.scheme-column:hover {
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.15);
  border-color: #c6e2ff;
}

.column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.total-price {
  font-weight: bold;
  font-size: 16px;
  color: #f56c6c;
}

.products-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.product-item {
  display: flex;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e6e6e6;
}

.product-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.product-image {
  width: 150px;
  height: 150px;
  flex-shrink: 0;
  background: #f7f7f7;
  border-radius: 4px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 商品名称样式 */
.product-name-row {
  display: flex;
  gap: 8px;
  line-height: 1.4;
}

.product-name-row strong {
  white-space: nowrap;
  color: #333;
}

.product-name-text {
  flex: 1;
  word-break: break-word;
  white-space: pre-line;
}

/* 基本信息样式 */
.basic-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 20px;
  margin-top: 8px;
}

.basic-info-grid div {
  font-size: 14px;
  color: #666;
}

.basic-info-grid strong {
  color: #333;
}

/* 弹窗样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .scheme-columns {
    grid-template-columns: 1fr;
  }

  .filter-row {
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .scheme-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .scheme-actions {
    width: 100%;
    justify-content: space-between;
  }

  .product-item {
    flex-direction: column;
  }

  .product-image {
    width: 100%;
    height: auto;
    aspect-ratio: 1/1;
  }

  .basic-info-grid {
    grid-template-columns: 1fr;
  }
}

.export-dialog .el-dialog__body {
  padding: 20px;
}

.export-content {
  position: relative;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

.export-tip {
  margin-top: 20px;
}


.export-toolbar {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.export-toolbar .filter-form {
  margin: 0;
  display: flex;
  align-items: center;
}

.export-toolbar .el-form-item {
  margin-bottom: 0;
  margin-right: 20px;
}

.export-toolbar .el-checkbox {
  font-weight: 600;
}

.filter-status {
  padding: 4px 8px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  color: #1890ff;
  font-size: 14px;
}

/* 表格样式优化 */
.export-content .el-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.export-content .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .export-dialog {
    width: 90% !important;
  }
}

@media (max-width: 768px) {
  .export-dialog {
    width: 95% !important;
  }

  .export-content .el-table {
    font-size: 12px;
  }
}
</style>